import React, { useState, useContext } from 'react'
import { Layout, Drawer } from 'antd'
import { isMobileOnly, isDesktop } from "react-device-detect"
import { FaTimes } from "react-icons/fa"
import { API } from '../../resources/constants';
import language from "../../resources/languages/fa_IR";

// Components
import Content from './content'
import Footer from './footer'
import Header from './header'
import Menu from './menu'

// Contexts
import GlobalContext from '../../contexts/global'

const { Layouts: { Dashboard: { Menu: MenuLanguage } } } = language
const { FILE_MANAGEMENT_FILE_DOWNLOAD } = API
const { Sider } = Layout

export default function Index() {
    const [collapsed, setCollapsed] = useState(false)
    const { user, meta, baseURL } = useContext(GlobalContext)

    return (
        <Layout className='dashboard-layout'>
            {
                user ? (
                    <>
                        {
                            isMobileOnly ? (
                                <Drawer
                                    title={MenuLanguage.title}
                                    closeIcon={<FaTimes size={19} />}
                                    placement="right"
                                    width="100%"
                                    zIndex={9999}
                                    open={collapsed}
                                    onClose={() => setCollapsed(!collapsed)}
                                >
                                    <Menu collapsed={collapsed} setCollapsed={setCollapsed} />
                                </Drawer>
                            ) : (
                                <Sider
                                    theme="light"
                                    trigger={null}
                                    collapsible
                                    collapsed={collapsed}
                                    width={250}
                                >
                                    <>
                                        <div
                                          className={"menu-logo"}
                                          style={{
                                              backgroundImage: collapsed ? `url(${baseURL + FILE_MANAGEMENT_FILE_DOWNLOAD + meta?.horizontalLogo?.id})` : `url(${baseURL + FILE_MANAGEMENT_FILE_DOWNLOAD + meta?.verticalLogo?.id})`
                                          }}
                                        />
                                        <Menu />
                                    </>
                                </Sider>
                            )
                        }
                        <Layout>
                            <Header collapsed={collapsed} setCollapsed={setCollapsed} />
                            <Content />
                            <Footer />
                        </Layout>
                    </>
                ) : (
                    <>
                        <Content />
                        <Footer />
                    </>
                )
            }
        </Layout>
    )
}
